import React from 'react';
import styled from 'styled-components';
import color from 'tinycolor2';
import { MaterialIcon, Button, AnimatedChip } from '@pearsontechnology/aero-components';

export const ProjectColumnText = styled.div`
  font-size: 14px;
  line-height: 19px;
`;

export const ColoredText = styled.span`
  color: ${(props) => props.color || 'rgba(0,0,0,0.4)'};
  ${(props) => props.workspaceRedesign && `
    position: relative;
    height: 40px;
    width: 40px;
    background: ${props.theme['themeId'] === 'dark'
    ? color(props.theme['color.purpleLight']).setAlpha(0.3).toString()
    : color(props.theme['color.purpleLight']).setAlpha(0.1).toString()};
    border-radius: 4px;
    
    & svg {
      position: absolute;
      color: ${props.theme['color.purpleLight']};
      top: 9px;
      left: 8px;
    }`}
`;

export const ActivityName = styled.span`
  margin-left: 15px;
`;

export const CourseType = styled.div`
  font-weight: 200;
  font-size: 14px;
`;

export const CourseInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  gap: 10px;
`;

export const ActivityNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${(props) =>
    props.theme.themeId === 'dark'
      ? props.theme['color.text.title']
      : props.theme['color.blackLighter']};
`;

export const ActivityWorkspaceProjectName = styled.div`
  margin-left: 15px;
  margin-bottom: 3px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 21px;
`;

export const GreyButton = ({ iconName, ...rest }) => (
  <Button iconOnly grey height={34} {...rest}>
    <MaterialIcon id={iconName} />
  </Button>
);

export const SortButton = styled(
  ({ sortOrder, ...rest }) =>
    (<GreyButton iconName={sortOrder === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'} {...rest} />),
)`
  margin-left: 5px;
  & i {
    color: ${(props) =>
    props.theme['themeId'] === 'dark'
      ? props.theme['color.greyDark']
      : props.theme['color.blackLighter']};
  }
`;

export const ActivityNameNew = styled.span`
  margin-left: 15px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
`;

export const StyledFavouriteIcon = styled.span`
  margin-right: -5px;
  &:focus-visible {
    outline: none;
    border: 2px solid ${(props) => props.theme['color.blueLight']};
  }
  
  &:hover {
    background: ${(props) => props.theme['themeId'] === 'dark'
    ? props.theme['color.greyDarker']
    : props.theme['color.greyLighter']};
    border-radius: 40px;
    & i {
      color: ${(props) => props.theme['color.blackLighter']};
    }
  }
`;

export const WorkspaceRedesignList = styled.div`
  background: ${(props) => props.theme['themeId'] === 'dark'
    ? props.theme['color.blackDark']
    : props.theme['color.white']};
`;

export const WorkspaceRedesignHeader = styled.div`
  color: ${(props) =>
    props.theme['themeId'] === 'dark'
      ? props.theme['color.greyDark']
      : props.theme['color.blackLighter']};
  
  & svg {
    color: ${(props) =>
    props.theme['themeId'] === 'dark'
      ? props.theme['color.greyDark']
      : props.theme['color.blackLighter']};
  }
`;

export const WorkspaceRedesignItem = styled.div`
  color: ${(props) =>
    props.theme['themeId'] === 'dark'
      ? props.theme['color.greyDark']
      : props.theme['color.blackLighter']};
  
  & i {
    color: ${(props) =>
    props.theme['themeId'] === 'dark'
      ? props.theme['color.greyDark']
      : props.theme['color.blackLighter']};
  }

  &:focus-visible {
    outline: none;
    border: 2px solid ${(props) => props.theme['color.blueLight']};
  }
  
  &:hover {
    outline: none;
    box-shadow: ${(props) => (`0 0 0 4px ${color(props.theme['color.text.body']).setAlpha(0.08).toString()}`)};
  }
`;

export const UpdatedAtSortHeader = styled.div`
  cursor: pointer;

  &:focus-visible {
    outline: none;
    border: 3px solid ${(props) => props.theme['color.blueLight']};
  }

  &:hover {
    color: ${(props) => props.theme['themeId'] === 'dark'
    ? props.theme['color.black']
    : props.theme['color.blackLighter']};
    background: ${(props) => props.theme['themeId'] === 'dark'
    ? props.theme['color.greyDarker']
    : props.theme['color.greyLighter']};

    & svg {
      color: ${(props) => props.theme['color.blackLighter']};
    }
  }
`;

export const TextWrapper = styled.div`
    width: 100%;
    padding-right: 1.5px;
    padding-left: 3px;
    line-height: 18px;
`;

export const IngestPillContainer = styled.div`
      margin-left: 8px;
`;

export const AnimatedChipThin = ({...rest}) => (
  <AnimatedChip
    {...rest}
    blue={true}
    animationTime="10s"
    style={{ marginLeft: '18px', height: '18px' }}
  >
  </AnimatedChip>
);
